module.exports = __webpack_public_path__ + "img/test-img.3beb686.png";